import React from 'react';

function ContactForm() {
  return (
    <div className="flex flex-col justify-center items-center text-white">
        <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSesTd7yGsBHRDsmoMxMdGIhkIpx-NBT8rJR3cDhPaD2KpX5Nw/viewform?embedded=true" width="400" height="400" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
     
    </div>
  );
}

export default ContactForm;



